import { faPowerOff } from '@fortawesome/free-solid-svg-icons'
import IconBadge from './icon-badge'

const SuperUserPermissionBadge = ({ count, displayCount = true }) => (
  <IconBadge
    icon={faPowerOff}
    iconColor="text-danger"
    textColor="text-danger"
    tooltipText="Super User Permissions"
    count={displayCount ? count : undefined}
    text={displayCount ? undefined : 'Superuser'}
    className="fw-normal ms-2"
    data-testid="risk-badge"
  />
)

export default SuperUserPermissionBadge
